<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M4.3 14.9c1.3-.1 2.5.9 2.6 2.2.6 8 4.8 13.1 13 15.8l.3.1c1 .3 1.7 1.2 1.7 2.3v6c0 1.4-1.1 2.5-2.5 2.5-1.3 0-2.4-1.1-2.5-2.4v-4.3h-.1c-9-3.4-14-9.9-14.8-19.3v-.3c-.1-1.3.9-2.5 2.3-2.6zm39.4.1c-1.3-.1-2.5.9-2.6 2.2-.6 8-4.8 13.1-13 15.8l-.3.1c-1 .3-1.7 1.2-1.7 2.3v6c0 1.4 1.1 2.5 2.5 2.5 1.3 0 2.4-1.1 2.5-2.4v-4.3h.1c9-3.4 14.1-9.9 14.8-19.3v-.3c.1-1.4-.9-2.5-2.3-2.6zM29.9 4.1c4.1 0 7.3 3.1 7.3 7.2s-3.1 7.6-8.1 12.1l-.4.3-.4.3-.2.2-.4.3-.4.3-.6.5-1 .9-.6.8c-.6.6-1.6.6-2.3 0l-.8-.6-1.2-1.1-.4-.4-.6-.5-.2-.2-.4-.3-.2-.2-.4-.3c-5-4.6-8.1-8-8.1-12.1s3.2-7.2 7.3-7.2c2.3 0 4.5 1 6 2.7 1.6-1.7 3.8-2.7 6.1-2.7zm0 0" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
